import { Language } from "./languages";
import { commonTranslations } from "./components/common";
import { historyTranslations } from "./pages/history";
import { homeTranslations } from "./pages/home";
import { authTranslations } from "./components/auth";
import { downloadsTranslations } from "./pages/downloads";

export const translations = {
  common: commonTranslations,
  history: historyTranslations,
  auth: authTranslations,
  downloads: downloadsTranslations,
  home: homeTranslations,
};

export type TranslationNamespace = keyof typeof translations;

export const getTranslation = (
  language: Language,
  namespace: TranslationNamespace,
  key: string,
): string => {
  const keys = key.split(".");
  let value: any = translations[namespace][language];

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      console.warn(
        `Translation missing: ${namespace}.${key} for language ${language}`,
      );
      return key;
    }
  }

  return value;
};
